import {useEffect, useState} from "react";

import YoutubePlayerManager, {CreateVideoOptions, Player} from "./YoutubePlayerManager";

const usePlayer = (elementId: string, options: CreateVideoOptions): Player | undefined => {
    const [player, setPlayer] = useState<Player>();

    useEffect(() => {
        YoutubePlayerManager
            .load(elementId, options)
            .then(setPlayer);
    }, [elementId, options.videoId]);

    useEffect(() => {
        if (!player) {
            return;
        }

        YoutubePlayerManager.register(player);

        return () => {
            YoutubePlayerManager.unregister(player);
            player.destroy();
        };
    }, [player, setPlayer]);

    return player;
};

export default usePlayer;
